export function getIngredientsWithMandaroty(arr) {
  return arr.filter(ingredient => ingredient.mandatory)
}
